namespace RedBullMOBILE360.Administration {
    export interface TranslationItem {
        Key?: string;
        SourceText?: string;
        TargetText?: string;
        CustomText?: string;
    }
}

